module.exports = __webpack_public_path__ + "static/media/edit.400e4363.svg";